module.exports = __webpack_public_path__ + "assets/redpack-begining-bg-ce0e6edd.png";